import { registerLocaleData } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import localeEo from '@angular/common/locales/eo';
import localeEsMx from '@angular/common/locales/es-MX';
import {
    ErrorHandler,
    Injector,
    LOCALE_ID,
    NgModule,
    TRANSLATIONS,
    TRANSLATIONS_FORMAT
} from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
    AbstractAnalyticsService,
    GoogleAnalyticsService,
    SegmentAnalyticsService
} from '@lsq-frontend/angular-shared/features/analytics';
import { SETTINGS } from '@lsq-frontend/angular-shared/settings';
import { AppSettings, environment } from '@lsq-frontend/fasttrack-shared/environment';
import { WhiteLabelModule } from '@lsq-frontend/fasttrack-shared/features/white-label-service';
import { RequestInterceptor } from '@lsq-frontend/fasttrack-shared/interceptors';
import { atlas } from '@lsq-frontend/fasttrack-shared/routing-atlas';
import { DashboardClaim } from '@lsq-frontend/remote-services/enterprise/common';
import {
    SendPhoneNumberVerificationCodeService,
    ValidatePhoneNumberVerificationCodeService
} from '@lsq-frontend/remote-services/enterprise/dashboard-services';
import {
    LsqAppRootModule,
    ATLAS,
    CLAIMS,
    errorHandlerFactory,
    LsqCommonModule,
    SEND_PHONE_NUMBER_VERIFICATION_CODE_SERVICE,
    SHA,
    VALIDATE_PHONE_NUMBER_VERIFICATION_CODE_SERVICE,
    CustomPreloadStrategy
} from '@lsq-frontend/common-ui';
import { I18n } from '@ngx-translate/i18n-polyfill';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginModule } from './login/login.module';
import sha from './app.sha.json';
import { BASE_PATH } from '@lsq-frontend/remote-services/ar-app';

registerLocaleData(localeEo, 'eo');
registerLocaleData(localeEsMx, 'es-MX');

@NgModule({
    imports: [
        BrowserAnimationsModule,
        LsqAppRootModule,
        LsqCommonModule.forRoot(),
        AppRoutingModule,
        WhiteLabelModule,

        LoginModule
    ],
    declarations: [AppComponent],
    providers: [
        AppSettings,
        { provide: CLAIMS, useValue: DashboardClaim },
        {
            provide: SEND_PHONE_NUMBER_VERIFICATION_CODE_SERVICE,
            useClass: SendPhoneNumberVerificationCodeService
        },
        {
            provide: VALIDATE_PHONE_NUMBER_VERIFICATION_CODE_SERVICE,
            useClass: ValidatePhoneNumberVerificationCodeService
        },
        { provide: HTTP_INTERCEPTORS, useClass: RequestInterceptor, multi: true },
        { provide: SETTINGS, useExisting: AppSettings },
        { provide: SHA, useValue: sha },
        { provide: ATLAS, useValue: atlas },
        { provide: TRANSLATIONS_FORMAT, useValue: '' },
        { provide: BASE_PATH, useValue: environment.httpApiServiceNameUrlMap.arApp },
        {
            provide: TRANSLATIONS,
            useFactory: (locale: string) => {
                locale = locale || 'en-US'; // default to english if no locale provided
                return require(`raw-loader!../locales/messages.${locale}.xlf`).default;
            },
            deps: [LOCALE_ID]
        },
        {
            provide: AbstractAnalyticsService,
            multi: true,
            useClass: SegmentAnalyticsService
        },
        {
            provide: AbstractAnalyticsService,
            multi: true,
            useClass: GoogleAnalyticsService
        },
        I18n,
        {
            provide: ErrorHandler,
            useFactory: errorHandlerFactory,
            deps: [SETTINGS, Injector]
        },
        CustomPreloadStrategy
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
    constructor() {
        // eslint-disable-next-line no-console
        console.debug('Loading fasttrack/AppModule.');
    }
}
